/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

const scrollToRef = (ref) => {
    if (window !== undefined) {
        window.scrollTo({
            top: ref.current.offsetTop - 100,
            left: 0,
            behavior: 'smooth',
        });
    }
};

export default scrollToRef;
